/*! Hype Fit v3 — Pawvenchy (Shopify, Kalles <hdt-variant-picker>) adapter. */
(function () {
  'use strict';
  var J = null;
  try { var el = document.getElementById('hype-fit-data'); if (el) J = JSON.parse(el.textContent); } catch (e) { J = null; }
  var touched = false;
  function mark(e) { if (e.isTrusted && e.target && e.target.closest && e.target.closest('hdt-variant-picker')) touched = true; }
  document.addEventListener('pointerdown', mark, true);
  document.addEventListener('keydown', mark, true);
  function picker() {
    var mount = document.querySelector('[data-hf3-mount]');
    var scope = mount && mount.closest('.hdt-product-info, .hdt-product__info, [id^="MainProduct"], section');
    return (scope && scope.querySelector('hdt-variant-picker')) || document.querySelector('hdt-variant-picker');
  }
  function controls(name) {
    var p = picker(); if (!p) return { radios: [], select: null };
    var radios = Array.prototype.filter.call(p.querySelectorAll('input[type="radio"]'), function (x) { return x.name === name || x.getAttribute('data-option-name') === name; });
    var select = Array.prototype.filter.call(p.querySelectorAll('select'), function (s) { return s.name === name || s.getAttribute('data-option-name') === name || (s.name || '').indexOf(name) > -1; })[0] || null;
    return { radios: radios, select: select };
  }
  window.HF3_ADAPTER = {
    brandKey: 'pawvenchy',
    poweredBy: 'Pawvenchy Size & Fit',
    sizeGuideUrl: '/pages/size-guide',
    contactUrl: '/pages/contact',
    breed: [['French Bulldog', 'XL–2XL'], ['Pug · Boston', 'L–XL'], ['Dachshund · Shih Tzu', 'M–L'], ['Yorkie · Chihuahua', 'XS–S']],
    vis: (J && J.vis) || {},
    data: function () {
      if (!J || !J.chart || !J.chart.rows) return null;
      var opts = (J.options || []).map(function (name, i) {
        var vals = [];
        if (i === J.size_index) vals = J.size_values || [];
        else (J.variants || []).forEach(function (v) { var x = v.options[i]; if (x != null && vals.indexOf(x) < 0) vals.push(x); });
        return { name: name, label: name, values: vals.map(function (v) { return { value: v, label: v }; }) };
      });
      return {
        productId: J.product_id,
        chart: { fitProfile: J.chart.fit_profile || 'regular_clothing', measurements: J.chart.measurements, rows: J.chart.rows },
        options: opts,
        sizeIdx: J.size_index,
        variants: (J.variants || []).map(function (v) { return { id: v.id, options: v.options, available: !!v.available }; })
      };
    },
    selected: function () {
      /* trust the variant the product form will actually add to cart */
      var m = document.querySelector('[data-hf3-mount]'), sc = m && m.closest('section, .hdt-product-info, [id^="MainProduct"]');
      var f = (sc && sc.querySelector('form[action*="/cart/add"] [name="id"]')) || document.querySelector('form[action*="/cart/add"] [name="id"]');
      var cur = f && (J.variants || []).filter(function (v) { return String(v.id) === String(f.value); })[0];
      if (cur) return cur.options.slice();
      return (J.options || []).map(function (name) {
        var c = controls(name);
        var r = c.radios.filter(function (x) { return x.checked; })[0];
        if (r) return r.value;
        if (c.select && c.select.value) return c.select.value;
        return null;
      });
    },
    select: function (idx, value) {
      var name = J.options[idx], c = controls(name);
      var r = c.radios.filter(function (x) { return x.value === value; })[0];
      if (r) {
        if (!r.checked) r.click();
        else r.dispatchEvent(new Event('change', { bubbles: true })); // checked but not applied yet (picker still hydrating)
        return true;
      }
      if (c.select) {
        c.select.value = value;
        c.select.dispatchEvent(new Event('change', { bubbles: true }));
        return c.select.value === value;
      }
      return false;
    },
    touched: function () { return touched; },
    allowAutoPick: function () { return !/[?&]variant=/.test(location.search); },
    mount: function (el) {
      var m = document.querySelector('[data-hf3-mount]');
      if (m) { m.hidden = false; m.appendChild(el); }
    },
    onChange: function (cb) {
      document.addEventListener('change', function (e) { if (e.target && e.target.closest && e.target.closest('hdt-variant-picker')) cb(); });
      window.addEventListener('popstate', cb);
      /* Kalles applies some variant changes asynchronously; follow the variant the form will add */
      var last = null;
      setInterval(function () { var f = document.querySelector('form[action*="/cart/add"] [name="id"]'); var v = f && f.value; if (v && v !== last) { if (last !== null) cb(); last = v; } }, 600);
    },
    outfitsUrl: function (p) { return p && parseFloat(p.chest) > 0 ? '/pages/outfits-that-fit' : ''; },
    noFit: function () { var m = document.querySelector('[data-hf3-mount]'); if (m) m.hidden = true; }
  };
})();

/*! Hype Fit — Size & Fit v3 (one interface: Size Guide + Find My Size, inline profile, outfits that fit).
 *  Shared by hypepups.com (WooCommerce) and pawvenchy.com (Shopify). Store specifics live in a small
 *  adapter (window.HF3_ADAPTER) loaded before this file. Profile + unit stay on the device:
 *  localStorage hp_dog_profile (cm) and hp_size_unit — same keys on both stores (no cross-domain sharing).
 *  Recommendation logic = the corrected Hype Fit recommender (function _ , unchanged). */
(function () {
  'use strict';
  var A = window.HF3_ADAPTER;
  if (!A || window.HF3) return;

  /* ---- corrected Hype Fit recommender, verbatim from hypepups.com (#416 function _) ---- */
  function _(t, e, made) {
  var LABEL = { chest: 'Chest', back: 'Back length', neck: 'Neck', head: 'Head girth', paw_length: 'Paw length', paw_width: 'Paw width' };
  var ORDER = ['chest', 'back', 'neck', 'head', 'paw_length', 'paw_width'];
  function measures() {
    var m = t.measurements && t.measurements.length ? t.measurements.slice() : ['chest'];
    return m.sort(function (a, b) { var x = ORDER.indexOf(a), y = ORDER.indexOf(b); return (x < 0 ? 99 : x) - (y < 0 ? 99 : y); });
  }
  function primaryKey() { var m = measures(); return m.indexOf('chest') !== -1 ? 'chest' : m[0]; }
  function axisStatus(key, n) {
    var a = [];
    for (var i = 0; i < t.rows.length; i++) { var c = t.rows[i][key]; if (c && typeof c.min === 'number') a.push({ idx: i, lo: c.min, hi: c.max }); }
    if (!a.length) return null;
    a.sort(function (x, y) { return x.lo - y.lo; });
    var hiMax = -Infinity, loMin = Infinity;
    a.forEach(function (x) { if (x.hi > hiMax) hiMax = x.hi; if (x.lo < loMin) loMin = x.lo; });
    if (n > hiMax) return { status: 'over' };
    if (n < loMin) return { status: 'under' };
    var inside = a.filter(function (x) { return n >= x.lo && n <= x.hi; });
    if (inside.length) {
      var best = inside[0], u = Infinity, tie = false;
      inside.forEach(function (x) {
        var c = (x.lo + x.hi) / 2, h = Math.max((x.hi - x.lo) / 2, 0.001), r = Math.abs(n - c) / h;
        if (r < u - 1e-9) { u = r; best = x; tie = false; }
        else if (Math.abs(r - u) <= 1e-9 && (x.hi > best.hi || (x.hi === best.hi && x.lo > best.lo))) { best = x; tie = true; }
      });
      return { status: tie ? 'between' : 'in', idx: best.idx };
    }
    return { status: 'gap', idx: a.filter(function (x) { return x.lo > n; })[0].idx };
  }
  function footwear() {
    var n = e.paw_length, w = e.paw_width;
    if (n == null || isNaN(n)) return { status: 'need' };
    var r = [];
    for (var s = 0; s < t.rows.length; s++) { var row = t.rows[s]; if (row.paw_length && typeof row.paw_length.min === 'number') r.push({ idx: s, size: row.size, len: row.paw_length.min, wid: row.paw_width ? row.paw_width.min : null }); }
    if (!r.length) return { status: 'need' };
    r.sort(function (a, b) { return a.len - b.len; });
    var maxLen = Math.max.apply(null, r.map(function (x) { return x.len; }));
    if (n > maxLen + 0.1) return { status: 'nomatch', dir: 'over', by: 'paw_length' };
    var l = r.filter(function (x) { return x.len >= n + 0.3; });
    if (!l.length) l = [r[r.length - 1]];
    var c = l[0], notes = [];
    if (w != null && !isNaN(w)) {
      var maxW = Math.max.apply(null, r.map(function (x) { return x.wid || 0; }));
      if (w > maxW + 0.4) return { status: 'nomatch', dir: 'over', by: 'paw_width' };
      var f = l.filter(function (x) { return (x.wid || 0) >= w; });
      if (f.length) { c = f[0]; if (c.idx > l[0].idx) notes.push('Sized up so the paw width fits.'); }
      else { c = l[l.length - 1]; notes.push('Snug on width — size up if your dog has wide paws.'); }
    }
    return finish({ status: 'ok', size: c.size, recIdx: c.idx, between: false, notes: notes, conf: 'high' });
  }
  function recommend() {
    if (!e) return { status: 'need' };
    if (t.fitProfile === 'footwear') return footwear();
    var pk = primaryKey();
    if (e[pk] == null || isNaN(e[pk])) return { status: 'need' };
    var ax = {};
    measures().forEach(function (k) { if (e[k] != null && !isNaN(e[k])) { var s = axisStatus(k, e[k]); if (s) ax[k] = s; } });
    var P = ax[pk];
    if (!P) return { status: 'need' };
    if (P.status === 'over' || P.status === 'under') return { status: 'nomatch', dir: P.status, by: pk };
    var last = t.rows.length - 1, f = P.idx, notes = [], backNote = false, sizedFor = [];
    var between = P.status === 'gap' || P.status === 'between';
    /* every other non-back measurement (neck on clothing; any extra fitted measurement) */
    for (var k in ax) {
      if (k === pk || k === 'back') continue;
      var s = ax[k];
      if (s.status === 'over') return { status: 'nomatch', dir: 'over', by: k };
      if (s.status === 'under' || s.idx <= P.idx) { if (s.status !== 'under' && s.idx < P.idx) notes.push((LABEL[k] || k) + ' runs roomy.'); continue; }
      if (s.idx - P.idx >= 2) return { status: 'nomatch', dir: 'proportion', by: k };
      if (s.idx > f) { f = s.idx; sizedFor.push(k); between = between || s.status === 'gap' || s.status === 'between'; }
    }
    /* back length: never blocks */
    var B = ax.back;
    if (B && pk !== 'back') {
      var bIdx = B.status === 'over' ? last + 1 : B.status === 'under' ? -1 : B.idx;
      if (bIdx === f + 1 && bIdx <= last) { f = bIdx; sizedFor.push('back'); between = between || B.status === 'gap' || B.status === 'between'; }
      else if (bIdx >= f + 2 || (bIdx > f && bIdx > last)) {
        backNote = true;
        if (f + 1 <= last) { f = f + 1; notes.push('Back length matches ' + (B.status === 'over' ? 'a size longer than this style makes' : t.rows[B.idx].size) + '; we sized up one for length, but this style may still sit a little short along the back.'); }
        else notes.push('Back length is longer than this style’s longest size, so it may sit a little short along the back.');
      } else if (bIdx < f) {
        if (bIdx <= f - 2 || bIdx < 0) { backNote = true; notes.push('Back length matches ' + (B.status === 'under' ? 'a size shorter than this style makes' : t.rows[B.idx].size) + ', so this style may sit a little long along the back.'); }
      }
    }
    if (f > P.idx && sizedFor.indexOf('back') === -1 && !backNote) notes.unshift((LABEL[pk] || pk) + ' runs roomy.');
    return finish({ status: 'ok', size: t.rows[f].size, recIdx: f, between: between, notes: notes, backNote: backNote, sizedFor: sizedFor, conf: f === P.idx && !backNote ? 'high' : 'medium' });
  }
  /* the chosen chart size must be a size the product is made in; if not, size up to the very next chart size */
  function finish(r) {
    if (r.status !== 'ok' || !made || made[r.recIdx]) return r;
    var j = r.recIdx + 1;
    if (j < t.rows.length && made[j]) {
      r.notes.unshift(t.rows[r.recIdx].size + ' isn’t made in this style, so we sized up to ' + t.rows[j].size + '.');
      r.skipped = t.rows[r.recIdx].size; r.recIdx = j; r.size = t.rows[j].size; r.between = true; r.conf = 'medium';
      return r;
    }
    var anyAbove = false; for (var k = r.recIdx + 1; k < t.rows.length; k++) if (made[k]) anyAbove = true;
    return { status: 'nomatch', dir: anyAbove ? 'gap' : 'over', by: primaryKey(), want: t.rows[r.recIdx].size };
  }
  return { recommend: recommend, axisStatus: axisStatus, measures: measures, primaryKey: primaryKey };
}

  var PK = 'hp_dog_profile', UK = 'hp_size_unit', CM = 2.54;
  var F = {
    chest: { label: 'Chest', long: 'Chest girth', hint: 'Around the widest part of the ribcage, just behind the front legs.', lo: 15, hi: 160 },
    back: { label: 'Back length', long: 'Back length', hint: 'From the base of the neck to the base of the tail, along the spine.', lo: 10, hi: 110 },
    neck: { label: 'Neck', long: 'Neck', hint: 'Around the base of the neck, where a collar sits. Leave two fingers of room.', lo: 10, hi: 90 },
    head: { label: 'Head', long: 'Head circumference', hint: 'Around the widest part of the head, in front of the ears.', lo: 12, hi: 80 },
    paw_length: { label: 'Paw length', long: 'Paw length', hint: 'Heel pad to the tip of the longest toe, with your dog standing.', lo: 1, hi: 20 },
    paw_width: { label: 'Paw width', long: 'Paw width', hint: 'Across the widest part of the paw, with your dog standing.', lo: 1, hi: 15 }
  };
  var CLOTHING = ['chest', 'back', 'neck'];
  var EX = { chest: 40, back: 30, neck: 28, head: 30, paw_length: 4.5, paw_width: 4 };
  var IC = {
    ruler: '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><rect x="2.5" y="8" width="19" height="8" rx="1.6"/><path d="M6.5 8v3M10 8v2M13.5 8v3M17 8v2"/></svg>',
    check: '<svg viewBox="0 0 16 16" aria-hidden="true" focusable="false"><path d="M3.2 8.4 6.4 11.4 12.8 4.8"/></svg>',
    x: '<svg viewBox="0 0 16 16" aria-hidden="true" focusable="false"><path d="M4 4l8 8M12 4l-8 8"/></svg>',
    alert: '<svg viewBox="0 0 16 16" aria-hidden="true" focusable="false"><circle cx="8" cy="8" r="6.2"/><path d="M8 4.8v4M8 11v.1"/></svg>',
    arrow: '<svg viewBox="0 0 16 16" aria-hidden="true" focusable="false"><path d="M3 8h9.5M9 4.5 12.5 8 9 11.5"/></svg>',
    down: '<svg viewBox="0 0 16 16" aria-hidden="true" focusable="false"><path d="M8 3v9.5M4.5 9 8 12.5 11.5 9"/></svg>',
    paw: '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><ellipse cx="12" cy="15.5" rx="4.6" ry="3.8"/><circle cx="6" cy="10" r="1.9"/><circle cx="9.6" cy="6.4" r="1.9"/><circle cx="14.4" cy="6.4" r="1.9"/><circle cx="18" cy="10" r="1.9"/></svg>'
  };

  /* ================= utilities ================= */
  function $(s, c) { return (c || document).querySelector(s); }
  function $$(s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); }
  function esc(t) { return String(t == null ? '' : t).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function num(v) { var n = parseFloat(String(v == null ? '' : v).replace(',', '.')); return isNaN(n) || n <= 0 ? null : n; }
  function fire(n) { try { document.dispatchEvent(new CustomEvent(n)); } catch (e) {} }
  function track(ev, d) {
    d = d || {};
    try { if (typeof window.gtag === 'function') window.gtag('event', ev, d); } catch (e) {}
    try { (window.dataLayer = window.dataLayer || []).push(Object.assign({ event: ev }, d)); } catch (e) {}
  }
  function getUnit() { try { return localStorage.getItem(UK) === 'in' ? 'in' : 'cm'; } catch (e) { return 'cm'; } }
  function setUnit(u) { try { localStorage.setItem(UK, u === 'in' ? 'in' : 'cm'); } catch (e) {} fire('hp:unit'); }
  function getProfile() { try { var p = JSON.parse(localStorage.getItem(PK) || 'null'); return p && typeof p === 'object' ? p : null; } catch (e) { return null; } }
  function saveProfile(p) { try { localStorage.setItem(PK, JSON.stringify(p)); } catch (e) {} fire('hp:profile'); }
  function clearProfile() { try { localStorage.removeItem(PK); } catch (e) {} fire('hp:profile'); }
  function hasAny(p, keys) { return !!p && keys.some(function (k) { return num(p[k]) !== null; }); }
  function dogName(p) { return p && p.name ? String(p.name).trim() : ''; }
  function who(p) { return dogName(p) || 'your pup'; }
  function Who(p) { return dogName(p) || 'Your pup'; }
  function poss(p) { var n = dogName(p); return n ? n + '’s' : 'your pup’s'; }
  function Poss(p) { var n = dogName(p); return n ? n + '’s' : 'Your pup’s'; }
  function fmt(cm, u) { if (cm == null) return '—'; return u === 'in' ? String(Math.round(cm / CM * 10) / 10) : String(Math.round(cm * 10) / 10); }
  function wu(cm, u) { return fmt(cm, u) + (u === 'in' ? ' in' : ' cm'); }
  function rng(c, u) { return !c || c.min == null ? '—' : (c.min === c.max ? fmt(c.min, u) : fmt(c.min, u) + '–' + fmt(c.max, u)); }
  function listJoin(a) { return a.length < 2 ? a.join('') : a.slice(0, -1).join(', ') + ' and ' + a[a.length - 1]; }
  function lower(k) { return F[k].long.charAt(0).toLowerCase() + F[k].long.slice(1); }

  /* size-label matching: exact normalised, then base token ("XS (Head Girth 26-32cm)" -> XS) when unambiguous */
  var AL = { XXL: '2XL', XXXL: '3XL', XXXXL: '4XL', 'ONE SIZE': 'ONESIZE', 'FREE SIZE': 'ONESIZE' };
  function norm(s) { var t = String(s == null ? '' : s).trim().toUpperCase().replace(/\s+/g, ' ').replace(/#$/, ''); return AL[t] || t; }
  function base(s) { var m = String(s == null ? '' : s).trim().toUpperCase().match(/^((?:\d?X{0,4}[SML])|XXS|FB2?|\d{1,2}#?)\s*(?:\(.*\)|\s+[\d.]+\s*[X×*].*|\s+[\d.]+\s*CM.*)$/); return m ? norm(m[1]) : null; }

  /* short display label: "S (Head Girth 28-34cm)" -> "S", "M 1.5x35cm" -> "M"; plain labels unchanged */
  function short(l) { var b = base(l); return b && String(l).trim().length > b.length ? b : String(l).trim(); }

  /* ================= context (which measurements belong to this product) ================= */
  function ctxFor(chart) {
    var fp = chart.fitProfile || 'regular_clothing';
    var core = _(chart, null);
    var ms = core.measures().filter(function (k) { return F[k]; });
    var kind = fp === 'footwear' ? 'footwear' : (fp === 'headwear' || (ms.length === 1 && ms[0] === 'head')) ? 'headwear' : 'clothing';
    var fields = kind === 'footwear' ? ['paw_length', 'paw_width'] : kind === 'headwear' ? ['head'] : CLOTHING.slice();
    var primary = kind === 'footwear' ? 'paw_length' : core.primaryKey();
    var roles = {};
    fields.forEach(function (k) { roles[k] = k === primary ? 'need' : (ms.indexOf(k) > -1 ? 'used' : 'other'); });
    return { kind: kind, fields: fields, measures: ms, primary: primary, roles: roles, fitProfile: fp };
  }

  /* ================= shared profile form (create + edit are the same form) ================= */
  var BADGE = { need: 'Needed for this item', used: 'Used for this item', other: 'Not used for this item', rec: 'Recommended' };
  function formHtml(o) {
    // o: {id, fields, roles, prof, unit, draft, nameField}
    var p = o.draft || o.prof || {};
    var h = '<div class="hf3-form" data-hf3-form="' + esc(o.id) + '">';
    if (o.nameField !== false) {
      h += '<div class="hf3-fld hf3-fld--name"><div class="hf3-fld-top"><label for="' + o.id + '-name">Dog’s name</label><span class="hf3-badge">Optional</span></div>' +
        '<div class="hf3-in"><input id="' + o.id + '-name" type="text" data-k="name" maxlength="24" autocomplete="off" spellcheck="false" placeholder="e.g. Milo" value="' + esc(dogName(p)) + '"></div></div>';
    }
    o.fields.forEach(function (k) {
      var v = num(p[k]), role = o.roles[k] || 'used';
      h += '<div class="hf3-fld is-' + role + '" data-fld="' + k + '"><div class="hf3-fld-top"><label for="' + o.id + '-' + k + '">' + esc(F[k].long) + '</label><span class="hf3-badge hf3-badge--' + role + '">' + esc(BADGE[role]) + '</span></div>' +
        '<div class="hf3-in"><input id="' + o.id + '-' + k + '" type="text" inputmode="decimal" autocomplete="off" data-k="' + k + '" value="' + (v === null ? '' : esc(fmt(v, o.unit))) + '" placeholder="e.g. ' + fmt(EX[k], o.unit) + '" aria-describedby="' + o.id + '-' + k + '-h"><span class="hf3-u">' + o.unit + '</span></div>' +
        '<p class="hf3-hint" id="' + o.id + '-' + k + '-h">' + esc(F[k].hint) + '</p><p class="hf3-ferr" role="alert" hidden></p></div>';
    });
    h += '</div>';
    return h;
  }
  /* read the form into a draft (cm). returns {draft, errors:{k:msg}} */
  function readForm(root, unit, roles, prev) {
    var d = Object.assign({}, prev || {}), errors = {};
    $$('input[data-k]', root).forEach(function (inp) {
      var k = inp.getAttribute('data-k');
      if (k === 'name') { var nm = inp.value.trim().slice(0, 24); if (nm) d.name = nm; else delete d.name; return; }
      var raw = inp.value.trim();
      if (!raw) { delete d[k]; if (roles[k] === 'need') errors[k] = F[k].long + ' is needed to size this item.'; return; }
      if (prev && num(prev[k]) !== null && raw === fmt(num(prev[k]), unit)) { d[k] = num(prev[k]); return; } // unchanged: keep exact cm (no unit round-trip drift)
      var n = num(raw);
      if (n === null) { errors[k] = 'Enter a number, like ' + (unit === 'in' ? '15.5' : '40') + '.'; return; }
      var cm = unit === 'in' ? Math.round(n * CM * 10) / 10 : Math.round(n * 10) / 10;
      if (cm < F[k].lo || cm > F[k].hi) {
        errors[k] = 'That looks ' + (cm < F[k].lo ? 'too small' : 'too large') + ' for ' + lower(k) + ' — check it’s in ' + (unit === 'in' ? 'inches' : 'centimetres') + '.';
        d[k] = cm; return;
      }
      d[k] = cm;
    });
    return { draft: d, errors: errors };
  }
  function showErrors(root, errors) {
    var first = null;
    $$('.hf3-fld[data-fld]', root).forEach(function (f) {
      var k = f.getAttribute('data-fld'), e = errors[k], el = $('.hf3-ferr', f), inp = $('input', f);
      f.classList.toggle('is-err', !!e);
      if (el) { el.hidden = !e; el.textContent = e || ''; }
      if (inp) inp.setAttribute('aria-invalid', e ? 'true' : 'false');
      if (e && !first) first = inp;
    });
    if (first) { try { first.focus(); first.scrollIntoView({ block: 'center', behavior: 'smooth' }); } catch (x) {} }
    return !first;
  }
  function commit(draft) {
    var p = Object.assign({}, getProfile() || {}, draft, { unit: 'cm', updatedAt: new Date().toISOString() });
    Object.keys(F).forEach(function (k) { if (!(k in draft)) delete p[k]; if (num(p[k]) === null) delete p[k]; });
    if (!draft.name) delete p.name;
    saveProfile(p);
    track('fit_profile_saved', { measurements: Object.keys(F).filter(function (k) { return num(p[k]) !== null; }).join(',') });
    return p;
  }
  /* draft merge: start from saved profile so hidden (specialist) fields are preserved */
  function startDraft() { return Object.assign({}, getProfile() || {}); }

  function unitToggle(u) {
    return '<span class="hf3-unit" role="group" aria-label="Units"><button type="button" data-hf3-unit="cm" aria-pressed="' + (u === 'cm') + '">cm</button><button type="button" data-hf3-unit="in" aria-pressed="' + (u === 'in') + '">in</button></span>';
  }
  function toast(msg) {
    var t = document.getElementById('hf3-toast');
    if (!t) { t = document.createElement('div'); t.id = 'hf3-toast'; t.className = 'hf3-toast'; t.setAttribute('role', 'status'); t.setAttribute('aria-live', 'polite'); document.body.appendChild(t); }
    t.innerHTML = IC.check + '<span>' + esc(msg) + '</span>'; t.classList.add('is-on');
    clearTimeout(t._t); t._t = setTimeout(function () { t.classList.remove('is-on'); }, 2600);
  }

  /* ================= product page ================= */
  function PDP(D) {
    var chart = D.chart, ctx = ctxFor(chart), unit = getUnit();
    var sizeIdx = D.sizeIdx, opts = D.options, sizeOpt = opts[sizeIdx];
    var rowOpt = {}; // chart row index -> size option {value,label}
    var editing = false, draft = null, tab = 'guide', modal = null, line = null, lastFocus = null, autoDone = false, clearArm = false;

    (function mapRows() {
      var used = {};
      var vals = sizeOpt.values;
      chart.rows.forEach(function (r, i) {
        var hit = vals.filter(function (v) { return norm(v.label) === norm(r.size) || norm(v.value) === norm(r.size); });
        if (hit.length === 1 && !used[hit[0].value]) { rowOpt[i] = hit[0]; used[hit[0].value] = 1; }
      });
      chart.rows.forEach(function (r, i) {
        if (rowOpt[i]) return;
        var b = base(r.size) || norm(r.size);
        var hit = vals.filter(function (v) { return !used[v.value] && ((base(v.label) || norm(v.label)) === b || (base(v.value) || norm(v.value)) === b); });
        if (hit.length === 1) { rowOpt[i] = hit[0]; used[hit[0].value] = 1; }
      });
    })();
    if (!Object.keys(rowOpt).length || sizeOpt.values.length < 2) { if (A.noFit) A.noFit(); return null; }
    var made = chart.rows.map(function (r, i) { return !!rowOpt[i]; }); // sizes this product is actually made in

    var soldIdx = Object.keys(rowOpt).map(Number).sort(function (a, b) { return a - b; });
    function rowOfValue(val) { for (var i in rowOpt) if (rowOpt[i].value === val) return +i; return -1; }
    function label(i) { return short(rowOpt[i] ? rowOpt[i].label : chart.rows[i].size); }
    function soldRange() {
      var idx = Object.keys(rowOpt).map(Number).sort(function (a, b) { return a - b; });
      return idx.length ? (idx.length === 1 ? label(idx[0]) : label(idx[0]) + '–' + label(idx[idx.length - 1])) : '';
    }
    /* availability of a size value, honouring the other options the shopper has chosen */
    function avail(val) {
      var sel = A.selected(), any = false, here = null, alts = [], seen = {};
      var vs = D.variants || [];
      if (!vs.length) return { any: true, here: true, alts: [] };
      vs.forEach(function (v) {
        var o = v.options[sizeIdx];
        if (o != null && o !== val) return;
        if (v.available) any = true;
        var same = v.options.every(function (x, i) { return i === sizeIdx || x == null || sel[i] == null || sel[i] === x; });
        if (same) here = (here || false) || !!v.available;
      });
      if (here === false) {
        opts.forEach(function (op, j) {
          if (j === sizeIdx) return;
          vs.forEach(function (v) {
            var o = v.options[sizeIdx];
            if ((o != null && o !== val) || !v.available) return;
            var ok = v.options.every(function (x, i) { return i === sizeIdx || i === j || x == null || sel[i] == null || sel[i] === x; });
            var vj = v.options[j];
            if (ok && vj != null && vj !== sel[j] && !seen[j + '|' + vj]) {
              seen[j + '|' + vj] = 1;
              var lab = (op.values.filter(function (x) { return x.value === vj; })[0] || { label: vj }).label;
              alts.push({ idx: j, value: vj, label: lab, optName: op.label });
            }
          });
        });
      }
      return { any: any, here: here === null ? any : here, alts: alts };
    }
    function selLabel(j) {
      var sel = A.selected(); if (sel[j] == null) return '';
      var o = opts[j].values.filter(function (x) { return x.value === sel[j]; })[0];
      return o ? o.label : sel[j];
    }

    /* ---------- evaluate the current state ---------- */
    function evaluate() {
      var p = getProfile();
      var st = { prof: p };
      if (!p || num(p[ctx.primary]) === null) { st.s = p && hasAny(p, ctx.fields) ? 'need' : (p && hasAny(p, Object.keys(F)) ? 'need' : 'empty'); st.missing = [ctx.primary]; return st; }
      var core = _(chart, p, made), r = core.recommend();
      st.r = r;
      if (r.status === 'nomatch' && r.dir === 'gap') { st.s = 'unsold'; st.idx = chart.rows.map(function (x) { return x.size; }).indexOf(r.want); return st; }
      if (r.status === 'need') { st.s = 'need'; st.missing = [ctx.primary]; return st; }
      if (r.status === 'nomatch') {
        st.s = r.dir === 'proportion' ? 'proportion' : 'nomatch'; st.dir = r.dir; st.by = r.by;
        if (st.s === 'proportion') {
          st.pts = core.measures().filter(function (k) { return num(p[k]) !== null; }).map(function (k) { var a = core.axisStatus(k, num(p[k])); return { k: k, v: num(p[k]), i: a && a.idx != null ? a.idx : -1 }; });
        }
        return st;
      }
      st.idx = r.recIdx; st.size = chart.rows[r.recIdx].size; st.between = !!r.between; st.backNote = !!r.backNote;
      st.missingOpt = ctx.kind === 'clothing' ? ctx.measures.filter(function (k) { return num(p[k]) === null; }) : (ctx.kind === 'footwear' && num(p.paw_width) === null ? ['paw_width'] : []);
      var o = rowOpt[r.recIdx];
      if (!o) {
        /* recommended chart row is not a size this product is made in: never recommend a nonexistent variant */
        if (r.recIdx < soldIdx[0]) { st.s = 'nomatch'; st.dir = 'under'; st.by = ctx.primary; }
        else if (r.recIdx > soldIdx[soldIdx.length - 1]) { st.s = 'nomatch'; st.dir = 'over'; st.by = ctx.primary; }
        else st.s = 'unsold';
        return st;
      }
      st.opt = o; st.size = short(o.label);
      var av = avail(o.value); st.av = av;
      if (!av.any) st.s = 'oos_all';
      else if (av.here === false) st.s = 'oos_here';
      else st.s = 'ok';
      var sel = A.selected()[sizeIdx];
      if (st.s === 'ok' && sel != null && sel !== o.value) { st.diff = { value: sel, label: selLabel(sizeIdx), idx: rowOfValue(sel) }; }
      st.selected = sel === o.value;
      st.why = why(st, p);
      return st;
    }
    function why(st, p) {
      var out = [], r = chart.rows[st.idx], S = st.size;
      if (ctx.kind === 'footwear') {
        out.push('Paw length ' + wu(num(p.paw_length), unit) + ' → size ' + S + ' (' + rng(r.paw_length, unit) + ' ' + unit + '), leaving a little room at the toes.');
        (st.r.notes || []).forEach(function (n) { out.push(n); });
        return out;
      }
      var core = _(chart, null);
      ctx.measures.forEach(function (k) {
        var v = num(p[k]); if (v === null) return;
        var a = core.axisStatus(k, v);
        var lab = F[k].label + ' ' + wu(v, unit);
        if (a && a.idx == null && k === 'back') { out.push(lab + (a.status === 'over' ? ' is longer than this style’s longest size, so ' + S + ' may sit a little short along the back.' : ' is shorter than this style’s shortest size, so ' + S + ' may sit a little long along the back.')); return; }
        if (a && a.idx == null && a.status === 'under') { out.push(lab + ' is below this style’s smallest ' + lower(k) + ', so ' + S + ' will be roomy there.'); return; }
        if (!a || a.idx == null) return;
        if (a.idx === st.idx) {
          if (a.status === 'between') out.push(lab + ' is right on the line between two sizes, so we went up to ' + S + ' (' + rng(r[k], unit) + ' ' + unit + ').');
          else if (a.status === 'gap') out.push(lab + ' falls in the gap between two sizes, so we went up to ' + S + ' (from ' + fmt(r[k].min, unit) + ' ' + unit + ').');
          else out.push(lab + ' sits within ' + S + ' (' + rng(r[k], unit) + ' ' + unit + ').');
        } else if (a.idx < st.idx && !rowOpt[a.idx] && st.r && st.r.skipped) {
          out.push(lab + ' sits within ' + short(chart.rows[a.idx].size) + ' (' + rng(chart.rows[a.idx][k], unit) + ' ' + unit + '), which isn’t made in this style, so we went up to ' + S + '.');
        } else if (a.idx < st.idx) {
          out.push(lab + ' matches a smaller size, so ' + S + ' may be a little roomy there.');
        } else if (k === 'back') {
          out.push(lab + ' matches ' + label(a.idx) + '. Chest decides the fit, so ' + S + ' may sit a little short along the back.');
        } else {
          out.push(lab + ' matches ' + label(a.idx) + ', so we sized up to ' + S + ' for ' + lower(k) + '.');
        }
      });
      return out;
    }

    /* ---------- fit line under the size selector ---------- */
    function renderLine() {
      if (!line) { line = document.createElement('div'); line.className = 'hf3-line hf3-root'; line.setAttribute('data-hf3-line', ''); }
      if (!line.isConnected) A.mount(line);
      var st = evaluate(), p = st.prof, h = '';
      var guide = '<button type="button" class="hf3-l-guide" data-hf3-open="guide">' + IC.ruler + '<span>Size guide</span></button>';
      if (st.s === 'empty') {
        h = guide + '<span class="hf3-l-sep" aria-hidden="true"></span><button type="button" class="hf3-l-link" data-hf3-open="find">Find my size</button>';
      } else if (st.s === 'need') {
        h = guide + '<span class="hf3-l-sep" aria-hidden="true"></span><button type="button" class="hf3-l-link" data-hf3-open="find">Add ' + esc(lower(ctx.primary)) + ' for ' + esc(poss(p)) + ' size</button>';
      } else if (st.s === 'ok') {
        h = '<span class="hf3-l-best is-ok">' + IC.check + '<span>' + esc(Poss(p)) + ' size: <b>' + esc(st.size) + '</b></span></span>' +
          (st.selected ? '' : '<button type="button" class="hf3-pill" data-hf3-use>Select ' + esc(st.size) + '</button>') +
          '<button type="button" class="hf3-l-link hf3-l-quiet" data-hf3-open="find">Details</button>';
      } else if (st.s === 'oos_here' || st.s === 'oos_all') {
        h = '<span class="hf3-l-best is-warn">' + IC.alert + '<span>' + esc(Poss(p)) + ' size <b>' + esc(st.size) + '</b> is sold out' + (st.s === 'oos_here' && selLabel(firstOther()) ? ' in ' + esc(selLabel(firstOther())) : '') + '</span></span>' +
          '<button type="button" class="hf3-l-link" data-hf3-open="find">' + (st.s === 'oos_here' ? 'See options' : 'What now?') + '</button>';
      } else {
        h = '<span class="hf3-l-best is-bad">' + IC.alert + '<span>No size in this style fits ' + esc(who(p)) + '</span></span><button type="button" class="hf3-l-link" data-hf3-open="find">See why</button>';
      }
      line.innerHTML = h;
      autoPick(st);
      if (modal && modal.classList.contains('is-open')) render();
    }
    function firstOther() { for (var j = 0; j < opts.length; j++) if (j !== sizeIdx && opts[j].values.length > 1) return j; return -1; }
    /* pre-select the recommended size once per page view, unless the shopper has already chosen options.
       Re-checks briefly because some themes pre-select the first variation after load. */
    function autoPick(st) {
      if (autoDone || st.s !== 'ok' || st.selected) return;
      autoDone = true;
      if (A.touched() || !A.allowAutoPick()) return;
      var toasted = false;
      [0, 1400, 3000].forEach(function (ms) {
        setTimeout(function () {
          if (A.touched()) return;
          var s2 = evaluate();
          if (s2.s === 'ok' && !s2.selected && A.select(sizeIdx, s2.opt.value, true) && !toasted) { toasted = true; toast(Poss(s2.prof) + ' size ' + s2.size + ' selected'); }
        }, ms);
      });
    }
    function useSize(o, alt) {
      if (alt) A.select(alt.idx, alt.value);
      var ok = A.select(sizeIdx, o.value);
      if (ok) { track('fit_select', { size: o.label, product_id: D.productId }); toast('Size ' + o.label + (alt ? ' in ' + alt.label : '') + ' selected'); }
      return ok;
    }

    /* ---------- modal ---------- */
    function build() {
      modal = document.createElement('div');
      modal.className = 'hf3-modal hf3-root hf3-brand-' + (A.brandKey || 'store');
      modal.id = 'hf3-modal';
      modal.setAttribute('aria-hidden', 'true');
      modal.innerHTML = '<div class="hf3-dialog" tabindex="-1" role="dialog" aria-modal="true" aria-labelledby="hf3-title">' +
        '<div class="hf3-head"><div class="hf3-titlerow"><h2 id="hf3-title">Size &amp; Fit</h2><button type="button" class="hf3-x" data-hf3-close aria-label="Close Size &amp; Fit">' + IC.x + '</button></div>' +
        '<div class="hf3-tabrow"><div class="hf3-tabs" role="tablist" aria-label="Size &amp; Fit"><button type="button" role="tab" class="hf3-tab" id="hf3-t-guide" data-hf3-tab="guide" aria-controls="hf3-p-guide">Size Guide</button><button type="button" role="tab" class="hf3-tab" id="hf3-t-find" data-hf3-tab="find" aria-controls="hf3-p-find">Find My Size</button></div><div class="hf3-unitwrap"></div></div></div>' +
        '<div class="hf3-body" tabindex="-1"><div class="hf3-pane" role="tabpanel" id="hf3-p-guide" aria-labelledby="hf3-t-guide" data-hf3-pane="guide"></div><div class="hf3-pane" role="tabpanel" id="hf3-p-find" aria-labelledby="hf3-t-find" data-hf3-pane="find"></div>' +
        '<button type="button" class="hf3-more" data-hf3-more tabindex="-1" aria-hidden="true">More below ' + IC.down + '</button></div>' +
        '<div class="hf3-foot"></div></div>';
      document.body.appendChild(modal);
      var body = $('.hf3-body', modal);
      body.addEventListener('scroll', moreHint, { passive: true });
      window.addEventListener('resize', moreHint);
      modal.addEventListener('mousedown', function (e) { modal._down = e.target === modal; });
      modal.addEventListener('click', onClick);
      modal.addEventListener('mouseup', function (e) { if (modal._down && e.target === modal) close(); modal._down = false; });
      modal.addEventListener('keydown', onKey);
      modal.addEventListener('input', function (e) { if (e.target.matches('input[data-k]')) { var f = e.target.closest('.hf3-fld'); if (f && f.classList.contains('is-err')) { f.classList.remove('is-err'); var er = $('.hf3-ferr', f); if (er) er.hidden = true; } } });
    }
    function moreHint() {
      if (!modal) return;
      var b = $('.hf3-body', modal), more = $('[data-hf3-more]', modal);
      var rest = b.scrollHeight - b.clientHeight - b.scrollTop;
      var on = rest > 24;
      b.classList.toggle('has-more', on);
      if (more) more.classList.toggle('is-on', on && b.scrollTop < 40);
    }
    function open(which, focusKey) {
      if (!modal) build();
      unit = getUnit();
      lastFocus = document.activeElement;
      var st = evaluate();
      tab = which || (st.s === 'empty' ? 'guide' : 'find');
      editing = false; draft = null; clearArm = false;
      render();
      modal.classList.add('is-open'); modal.setAttribute('aria-hidden', 'false');
      document.documentElement.classList.add('hf3-lock');
      $('.hf3-body', modal).scrollTop = 0;
      setTimeout(function () {
        moreHint();
        var f = focusKey && $('input[data-k="' + focusKey + '"]', modal);
        try { (f || $('.hf3-dialog', modal)).focus({ preventScroll: !f }); } catch (e) {}
      }, 60);
      track('fit_open', { product_id: D.productId, tab: tab, state: st.s });
    }
    function close() {
      if (!modal) return;
      modal.classList.remove('is-open'); modal.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove('hf3-lock');
      try { lastFocus && lastFocus.focus && lastFocus.focus({ preventScroll: true }); } catch (e) {}
    }
    function setTab(t, focus) {
      if (tab === 'find' && t !== 'find' && editing) captureDraft();
      tab = t; render(); $('.hf3-body', modal).scrollTop = 0; moreHint();
      if (focus) { var b = $('.hf3-tab.is-on', modal); try { b.focus(); } catch (e) {} }
      if (t === 'find') track('fit_find_open', { product_id: D.productId });
    }
    function captureDraft() {
      var root = $('[data-hf3-form]', modal);
      if (root) draft = readForm(root, unit, ctx.roles, draft || startDraft()).draft;
    }
    function render() {
      var st = evaluate();
      $$('.hf3-tab', modal).forEach(function (b) { var on = b.getAttribute('data-hf3-tab') === tab; b.classList.toggle('is-on', on); b.setAttribute('aria-selected', String(on)); b.tabIndex = on ? 0 : -1; });
      $$('.hf3-pane', modal).forEach(function (p) { p.classList.toggle('is-on', p.getAttribute('data-hf3-pane') === tab); });
      $('.hf3-unitwrap', modal).innerHTML = unitToggle(unit);
      var findForm = editing || st.s === 'empty' || st.s === 'need', formMode = tab === 'find' && findForm;
      modal.classList.toggle('is-form', findForm);
      $('[data-hf3-pane="guide"]', modal).innerHTML = guideHtml(st);
      $('[data-hf3-pane="find"]', modal).innerHTML = findForm ? formPaneHtml(st) : resultPaneHtml(st);
      $('.hf3-foot', modal).innerHTML = footHtml(st, formMode);
      setTimeout(moreHint, 0);
    }

    /* ---------- Size Guide pane ---------- */
    function guideHtml(st) {
      var p = st.prof, ms = ctx.measures, recI = (st.s === 'ok' || st.s === 'oos_here' || st.s === 'oos_all' || st.s === 'unsold') ? st.idx : -1;
      var recbar = '';
      if (st.s === 'ok') recbar = '<div class="hf3-recbar is-ok">' + IC.check + '<span>' + esc(Poss(p)) + ' size in this style: <b>' + esc(st.size) + '</b>' + (st.between ? ' <i>(between sizes — sized up for a little extra room)</i>' : '') + '</span><button type="button" class="hf3-tlink" data-hf3-tab="find">Why?</button></div>';
      else if (st.s === 'oos_here' || st.s === 'oos_all') recbar = '<div class="hf3-recbar is-warn">' + IC.alert + '<span>' + esc(Poss(p)) + ' size, <b>' + esc(st.size) + '</b>, is sold out' + (st.s === 'oos_here' ? ' in this option' : '') + '.</span><button type="button" class="hf3-tlink" data-hf3-tab="find">Options</button></div>';
      else if (st.s === 'nomatch' || st.s === 'proportion' || st.s === 'unsold') recbar = '<div class="hf3-recbar is-bad">' + IC.alert + '<span>No size in this style fits ' + esc(who(p)) + '.</span><button type="button" class="hf3-tlink" data-hf3-tab="find">See why</button></div>';
      /* only sizes this product is actually made in, in the store's size order */
      var rows = sizeOpt.values.map(function (o) {
        var i = rowOfValue(o.value);
        if (i < 0) return '<tr class="is-nodata"><th scope="row"><span class="hf3-sz">' + esc(o.label) + '</span><span class="hf3-tag">No measurements yet</span></th>' + ms.map(function () { return '<td>—</td>'; }).join('') + '</tr>';
        var r = chart.rows[i], out = !avail(o.value).any, isRec = i === recI;
        var tag = isRec ? '<span class="hf3-tag is-rec">' + esc(dogName(p) || 'Your pup') + '</span>' : out ? '<span class="hf3-tag is-out">Sold out</span>' : '';
        return '<tr class="' + (isRec ? 'is-rec' : '') + (out ? ' is-out' : '') + '"><th scope="row"><span class="hf3-sz">' + esc(o.label) + '</span>' + tag + '</th>' + ms.map(function (k) { return '<td>' + esc(rng(r[k], unit)) + '</td>'; }).join('') + '</tr>';
      }).join('');
      var you = '';
      var missingRows = sizeOpt.values.filter(function (o) { return rowOfValue(o.value) < 0; });
      if (missingRows.length) { try { console.warn('[Hype Fit] size(s) without verified chart rows:', missingRows.map(function (o) { return o.label; }).join(', '), 'product', D.productId); } catch (e) {} }
      var table = '<div class="hf3-tablewrap"><table class="hf3-table"><caption class="hf3-sr">Size chart in ' + (unit === 'in' ? 'inches' : 'centimetres') + '</caption><thead><tr><th scope="col">Size</th>' + ms.map(function (k) { return '<th scope="col">' + esc(F[k].label) + '</th>'; }).join('') + '</tr></thead><tbody>' + rows + you + '</tbody></table></div>';
      var note = (missingRows.length ? '<p class="hf3-note hf3-note--warn">' + IC.alert + '<span>We don’t have verified measurements for ' + esc(listJoin(missingRows.map(function (o) { return o.label; }))) + ' in this style yet, so we won’t recommend ' + (missingRows.length > 1 ? 'those sizes' : 'that size') + '.</span></p>' : '') + '<p class="hf3-note">' + (ctx.kind === 'footwear' ? 'Choose the size whose paw length is just above your dog’s — a little room at the toes is right.' : 'Measurements are your dog’s body, not the garment. Between two sizes? Choose the larger one.') + '</p>';
      var breed = '';
      if (A.breed && ctx.kind === 'clothing' && chart.fitProfile === 'regular_clothing') {
        breed = '<section class="hf3-breed" aria-labelledby="hf3-breed-h"><div class="hf3-breed-top"><h3 id="hf3-breed-h">Breed reference</h3><span class="hf3-badge">General guide only</span></div>' +
          '<ul class="hf3-chips">' + A.breed.map(function (b) { return '<li><span>' + esc(b[0]) + '</span><b>' + esc(b[1]) + '</b></li>'; }).join('') + '</ul>' +
          '<p class="hf3-small">Typical sizes across our range. Dogs of the same breed vary, and styles differ — your dog’s measurements decide the size.</p></section>';
      }
      var left = '<div class="hf3-col">' + recbar + '<div class="hf3-sec-top"><h3 class="hf3-h">Size chart</h3><span class="hf3-sub">Your dog’s measurements, in ' + (unit === 'in' ? 'inches' : 'cm') + '</span></div>' + table + note + breed + '</div>';
      var right = '<div class="hf3-col">' + measureHtml(ms, p) + '<p class="hf3-powered">' + (A.sizeGuideUrl ? '<a class="hf3-tlink" href="' + esc(A.sizeGuideUrl) + '">Full size guide</a> · ' : '') + esc(A.poweredBy || 'Powered by Hype Fit™') + '</p></div>';
      return '<div class="hf3-grid">' + left + right + '</div>';
    }
    function measureHtml(ms, p, compact) {
      var vis = A.vis && (A.vis[ms.join('+')] || A.vis[ms.slice().sort().join('+')]);
      if (!vis && A.vis) { var alt = ms.filter(function (k) { return k !== 'neck'; }); vis = A.vis[alt.join('+')]; }
      return '<section class="hf3-measure' + (compact ? ' is-compact' : '') + '" id="hf3-howto" aria-labelledby="hf3-howto-h"><h3 class="hf3-h" id="hf3-howto-h">How to measure</h3>' +
        (vis ? '<div class="hf3-visbox"><img class="hf3-vis" src="' + esc(vis) + '" alt="How to measure: ' + esc(ms.map(function (k) { return F[k].long; }).join(', ')) + '" width="800" height="700" loading="lazy" decoding="async"></div>' : '') +
        '<ol class="hf3-steps">' + ms.map(function (k, i) {
          var v = p ? num(p[k]) : null;
          return '<li><span class="hf3-num">' + (ms.length > 1 ? i + 1 : '•') + '</span><div><b>' + esc(F[k].long) + '</b><span>' + esc(F[k].hint) + '</span>' + (v !== null ? '<em>' + IC.check + 'Saved: ' + esc(wu(v, unit)) + '</em>' : '') + '</div></li>';
        }).join('') + '<li class="is-tip"><span class="hf3-num">i</span><div><span>Use a soft tape, snug but not tight, with your dog standing naturally.</span></div></li></ol></section>';
    }

    /* ---------- Find My Size: form mode ---------- */
    function formPaneHtml(st) {
      var p = st.prof, d = draft || startDraft(), head;
      var hasSaved = p && hasAny(p, Object.keys(F));
      if (!hasSaved) head = '<div class="hf3-intro"><h3>Find ' + esc(poss(d)) + ' size</h3><p>Measure once. We’ll check this style’s size chart for you — and remember it for every other product.</p></div>';
      else if (st.s === 'need' && !editing) head = '<div class="hf3-intro"><h3>Add ' + esc(poss(p)) + ' ' + esc(lower(ctx.primary)) + '</h3><p>' + (ctx.kind === 'clothing' ? 'This item is sized by ' + esc(lower(ctx.primary)) + '.' : ctx.kind === 'headwear' ? 'Hats are sized by head circumference.' : 'Shoes are sized by paw length.') + ' Your other saved measurements stay as they are.</p></div>';
      else head = '<div class="hf3-intro"><h3>Edit ' + esc(poss(p)) + ' measurements</h3><p>Update any measurement — we’ll recheck the size straight away.</p></div>';
      var form = formHtml({ id: 'hf3-f', fields: ctx.fields, roles: ctx.roles, prof: p, draft: d, unit: unit });
      var tools = '<div class="hf3-formtools"><button type="button" class="hf3-tlink" data-hf3-howto>How to measure</button>' +
        (hasSaved ? '<button type="button" class="hf3-tlink hf3-danger" data-hf3-clear>' + (clearArm ? 'Tap again to clear everything' : 'Clear saved measurements') + '</button>' : '') + '</div>' +
        '<p class="hf3-small">' + (ctx.kind === 'clothing' ? 'Hat and shoe sizes use head and paw measurements — you’ll be asked for those on hats and shoes. ' : '') + 'Saved on this device — no account needed.</p>';
      return '<div class="hf3-grid hf3-grid--find"><div class="hf3-col">' + head + form + tools + '</div><div class="hf3-col hf3-desk">' + measureHtml(ctx.fields, d, true) + '</div></div>';
    }

    /* ---------- Find My Size: result mode ---------- */
    function resultPaneHtml(st) {
      var p = st.prof, card = '', acts = [];
      var shop = outfitsLink(p);
      if (st.s === 'ok') {
        card = '<div class="hf3-res is-ok"><span class="hf3-kick">Recommended for ' + esc(who(p)) + '</span><div class="hf3-size">' + esc(st.size) + '</div>' +
          (st.between ? '<p class="hf3-text"><b>We recommend ' + esc(st.size) + ' for ' + esc(who(p)) + '.</b></p>' : '') +
          '<p class="hf3-pillline ' + (st.between || st.backNote ? 'is-up' : 'is-ok') + '">' + (st.backNote ? ((st.r.notes || []).join(' ').indexOf('sized up one') > -1 ? 'Sized up one for back length' : 'Chest decides the size') : st.between ? 'Between sizes? We’ve sized up for a little extra room.' : 'Within ' + esc(st.size) + '’s range') + '</p>' +
          '<ul class="hf3-why">' + st.why.map(function (l) { return '<li>' + esc(l) + '</li>'; }).join('') + '</ul>' +
          (st.missingOpt && st.missingOpt.length ? '<p class="hf3-tip">' + IC.paw + '<span>Add ' + esc(listJoin(st.missingOpt.map(lower))) + ' for an even closer fit. <button type="button" class="hf3-tlink" data-hf3-edit="' + st.missingOpt[0] + '">Add now</button></span></p>' : '') +
          (st.diff ? diffHtml(st) : '') + '</div>';
      } else if (st.s === 'oos_here') {
        var on = selLabel(firstOther());
        card = '<div class="hf3-res is-warn"><span class="hf3-kick">Best fit for ' + esc(who(p)) + '</span><div class="hf3-size">' + esc(st.size) + '</div>' +
          '<p class="hf3-pillline is-bad">Sold out' + (on ? ' in ' + esc(on) : ' in this option') + '</p>' +
          '<p class="hf3-text">Size ' + esc(st.size) + ' is still available in:</p><div class="hf3-alts">' + st.av.alts.map(function (a, i) { return '<button type="button" class="hf3-alt" data-hf3-alt="' + i + '">' + esc(a.label) + '<small>' + esc(st.size) + '</small></button>'; }).join('') + '</div>' +
          '<ul class="hf3-why">' + st.why.map(function (l) { return '<li>' + esc(l) + '</li>'; }).join('') + '</ul></div>';
      } else if (st.s === 'oos_all') {
        card = '<div class="hf3-res is-warn"><span class="hf3-kick">Best fit for ' + esc(who(p)) + '</span><div class="hf3-size">' + esc(st.size) + '</div><p class="hf3-pillline is-bad">Sold out right now</p>' +
          '<p class="hf3-text">' + esc(Poss(p)) + ' size is sold out in every option of this style. We’d rather not suggest a size that won’t fit — ' + (shop ? 'shop other outfits in ' + esc(poss(p)) + ' size instead.' : 'check back soon.') + '</p>' +
          '<ul class="hf3-why">' + st.why.map(function (l) { return '<li>' + esc(l) + '</li>'; }).join('') + '</ul></div>';
      } else if (st.s === 'unsold') {
        var lo = soldIdx.filter(function (i) { return i < st.idx; }).pop(), hi = soldIdx.filter(function (i) { return i > st.idx; })[0];
        card = '<div class="hf3-res is-bad"><span class="hf3-kick">No size in this style fits ' + esc(who(p)) + '</span><h3 class="hf3-headline">' + esc(Poss(p)) + ' size falls between this style’s sizes</h3>' +
          '<p class="hf3-text">' + esc(Poss(p)) + ' measurements sit between <b>' + esc(label(lo)) + '</b> and <b>' + esc(label(hi)) + '</b> on this chart — too big for ' + esc(label(lo)) + ' and too small for ' + esc(label(hi)) + ', so neither is a confident fit.</p></div>';
      } else if (st.s === 'nomatch') {
        var k = st.by, v = num(p[k]);
        var over = st.dir === 'over';
        var ei = over ? soldIdx[soldIdx.length - 1] : soldIdx[0];
        var edge = chart.rows[ei];
        var edgeLabel = label(ei);
        card = '<div class="hf3-res is-bad"><span class="hf3-kick">No size in this style fits ' + esc(who(p)) + '</span><h3 class="hf3-headline">' + (k === 'back' ? (over ? 'Every size here is too short for ' : 'Every size here is too long for ') : (over ? 'Every size here is too small for ' : 'Every size here is too big for ')) + esc(who(p)) + '</h3>' +
          '<p class="hf3-text">' + esc(Poss(p)) + ' ' + esc(lower(k)) + ' is <b>' + esc(wu(v, unit)) + '</b>. ' + (over ? 'The largest size, ' + esc(edgeLabel) + ', fits up to ' + esc(wu(edge[k] ? edge[k].max : null, unit)) + '.' : 'The smallest size, ' + esc(edgeLabel) + ', starts at ' + esc(wu(edge[k] ? edge[k].min : null, unit)) + '.') + '</p>' +
          '<p class="hf3-small">If you measured over a thick coat or pulled the tape loose, a quick re-measure can help.</p></div>';
      } else if (st.s === 'proportion') {
        card = '<div class="hf3-res is-bad"><span class="hf3-kick">No single size fits ' + esc(who(p)) + '</span><h3 class="hf3-headline">' + esc(Poss(p)) + ' measurements point to different sizes</h3>' +
          '<ul class="hf3-pts">' + st.pts.map(function (x) { return '<li><span>' + esc(F[x.k].label) + ' ' + esc(wu(x.v, unit)) + '</span><b>' + esc(x.i > -1 ? label(x.i) : '—') + '</b></li>'; }).join('') + '</ul>' +
          '<p class="hf3-text">That’s more than one size apart, so any size would be too tight in one place or too loose in another. Double-check the measurements, or shop styles that suit ' + esc(poss(p)) + ' shape.</p></div>';
      }
      var summary = '<div class="hf3-prof"><div class="hf3-prof-top"><span class="hf3-kick">' + esc(Poss(p)) + ' measurements</span><button type="button" class="hf3-tlink" data-hf3-edit aria-label="Edit ' + esc(poss(p)) + ' measurements">Edit</button></div><ul class="hf3-vals">' +
        ctx.fields.map(function (k) { var v = num(p[k]); return '<li class="' + (v === null ? 'is-miss' : '') + (ctx.measures.indexOf(k) < 0 ? ' is-unused' : '') + '"><span>' + esc(F[k].label) + '</span><b>' + (v === null ? 'Not added' : esc(wu(v, unit))) + '</b></li>'; }).join('') + '</ul></div>';
      var more = [];
      if (shop && st.s !== 'oos_all' && !(st.s === 'nomatch' || st.s === 'proportion' || st.s === 'unsold')) more.push('<a class="hf3-row" href="' + esc(shop) + '" data-hf3-shop><span><b>Shop outfits that fit ' + esc(who(p)) + '</b><small>Every style checked against ' + esc(poss(p)) + ' measurements</small></span>' + IC.arrow + '</a>');
      if (st.s === 'nomatch' || st.s === 'proportion') more.push('<button type="button" class="hf3-row" data-hf3-howto><span><b>Check how to measure</b><small>Snug tape, dog standing</small></span>' + IC.arrow + '</button>');
      if (A.contactUrl && (st.s === 'proportion' || st.s === 'nomatch' || st.s === 'unsold')) more.push('<a class="hf3-row" href="' + esc(A.contactUrl) + '"><span><b>Ask us</b><small>We’ll help you choose</small></span>' + IC.arrow + '</a>');
      return '<div class="hf3-grid hf3-grid--find"><div class="hf3-col">' + card + '</div><div class="hf3-col">' + summary + (more.length ? '<div class="hf3-rows">' + more.join('') + '</div>' : '') + '</div></div>';
    }
    function diffHtml(st) {
      var d = st.diff, r = chart.rows[st.idx], dr = d.idx > -1 ? chart.rows[d.idx] : null, k = ctx.primary, p = st.prof;
      var t;
      if (!dr) t = 'Size <b>' + esc(d.label) + '</b> is selected. ' + esc(Poss(p)) + ' best fit is ' + esc(st.size) + '.';
      else if (d.idx > st.idx) t = 'Size <b>' + esc(d.label) + '</b> is selected — a size up. It will likely be roomy' + (dr[k] ? ' — ' + esc(d.label) + ' starts at ' + esc(wu(dr[k].min, unit)) + ' ' + esc(lower(k)) + ', and ' + esc(who(p)) + ' is ' + esc(wu(num(p[k]), unit)) : '') + '.';
      else t = 'Size <b>' + esc(d.label) + '</b> is selected — a size down. It will likely be tight' + (dr[k] ? ' — ' + esc(d.label) + ' fits up to ' + esc(wu(dr[k].max, unit)) + ' ' + esc(lower(k)) + ', and ' + esc(who(p)) + ' is ' + esc(wu(num(p[k]), unit)) : '') + '.';
      return '<div class="hf3-diff">' + IC.alert + '<p>' + t + '</p></div>';
    }
    function factsHtml(p) {
      return '<ul class="hf3-pts">' + ctx.measures.filter(function (k) { return num(p[k]) !== null; }).map(function (k) { var a = _(chart, null).axisStatus(k, num(p[k])); return '<li><span>' + esc(F[k].label) + ' ' + esc(wu(num(p[k]), unit)) + '</span><b>' + esc(a && a.idx != null ? short(chart.rows[a.idx].size) : '—') + '</b></li>'; }).join('') + '</ul>';
    }
    function outfitsLink(p) { return p && A.outfitsUrl ? A.outfitsUrl(p) : ''; }

    /* ---------- sticky footer: always one clear primary action ---------- */
    function footHtml(st, formMode) {
      var p = st.prof, shop = outfitsLink(p);
      var prim = '', sec = '';
      if (tab === 'guide') {
        if (st.s === 'ok' && !st.selected) prim = btn('use', 'Use size ' + st.size);
        else if (st.s === 'ok') prim = btn('close', 'Done — size ' + st.size + ' selected');
        else if (st.s === 'empty' || st.s === 'need') { sec = '<span class="hf3-foot-t">Not sure? Enter ' + esc(poss(p)) + ' measurements and we’ll pick the size.</span>'; prim = btn('find', 'Find my size'); }
        else { sec = '<span class="hf3-foot-t">' + esc(Poss(p)) + ' result is on the Find My Size tab.</span>'; prim = btn('find', 'See ' + poss(p) + ' fit'); }
      } else if (formMode) {
        prim = btn('save', st.s === 'empty' ? 'Save & find my size' : 'Save & see size');
        if (editing && st.s !== 'empty' && st.s !== 'need') sec = '<button type="button" class="hf3-btn hf3-btn--text" data-hf3-act="cancel">Cancel</button>';
      } else if (st.s === 'ok') {
        prim = st.selected ? btn('close', 'Done — size ' + st.size + ' selected') : btn('use', 'Use size ' + st.size);
      } else if (st.s === 'oos_here' && st.av.alts.length) {
        prim = btn('alt0', 'Choose ' + st.size + ' in ' + st.av.alts[0].label);
      } else if (shop) {
        prim = '<a class="hf3-btn hf3-btn--primary" href="' + esc(shop) + '" data-hf3-shop>Shop outfits that fit ' + esc(who(p)) + '</a>';
      } else {
        prim = btn('edit', 'Edit measurements');
      }
      return (sec ? sec : '') + prim;
    }
    function btn(act, t) { return '<button type="button" class="hf3-btn hf3-btn--primary" data-hf3-act="' + act + '">' + esc(t) + '</button>'; }

    function save() {
      var root = $('[data-hf3-form]', modal);
      var res = readForm(root, unit, ctx.roles, draft || startDraft());
      if (!showErrors(root, res.errors)) return;
      var before = getProfile();
      commit(res.draft);
      editing = false; draft = null; clearArm = false; autoDone = true;
      var st = evaluate();
      if (st.s === 'ok' && !st.selected && A.select(sizeIdx, st.opt.value)) { toast(Poss(st.prof) + ' size ' + st.size + ' selected'); st = evaluate(); }
      render(); renderLine();
      $('.hf3-body', modal).scrollTop = 0;
      track('fit_result', { state: st.s, product_id: D.productId, first: !before });
    }

    function onClick(e) {
      var t = e.target.closest ? e.target : null; if (!t) return;
      var x;
      if (t.closest('[data-hf3-close]')) { close(); return; }
      if ((x = t.closest('[data-hf3-tab]'))) { setTab(x.getAttribute('data-hf3-tab')); return; }
      if ((x = t.closest('[data-hf3-unit]'))) {
        var u = x.getAttribute('data-hf3-unit'); if (u === unit) return;
        if (modal.classList.contains('is-form')) captureDraft();
        unit = u; setUnit(u); render(); renderLine(); return;
      }
      if ((x = t.closest('[data-hf3-edit]'))) { editing = true; draft = null; clearArm = false; tab = 'find'; render(); $('.hf3-body', modal).scrollTop = 0; var fk = x.getAttribute('data-hf3-edit'); var f = $('input[data-k="' + (fk || ctx.primary) + '"]', modal); if (f) setTimeout(function () { try { f.focus(); } catch (er) {} }, 30); return; }
      if (t.closest('[data-hf3-howto]')) { if (modal.classList.contains('is-form')) captureDraft(); tab = 'guide'; render(); var h = $('#hf3-howto', modal); if (h) setTimeout(function () { h.scrollIntoView({ block: 'start', behavior: 'smooth' }); }, 30); return; }
      if (t.closest('[data-hf3-clear]')) {
        if (!clearArm) { captureDraft(); clearArm = true; render(); setTimeout(function () { if (clearArm) { clearArm = false; if (modal.classList.contains('is-open')) { captureDraft(); render(); } } }, 4000); return; }
        clearProfile(); clearArm = false; editing = true; draft = {}; render(); renderLine(); toast('Saved measurements cleared'); track('fit_profile_cleared', {}); return;
      }
      if ((x = t.closest('[data-hf3-alt]'))) { var st0 = evaluate(); var a = st0.av && st0.av.alts[+x.getAttribute('data-hf3-alt')]; if (a && useSize(st0.opt, a)) close(); return; }
      if (t.closest('[data-hf3-shop]')) { track('fit_shop_outfits', { source: 'pdp', product_id: D.productId }); return; }
      if ((x = t.closest('[data-hf3-act]'))) {
        var act = x.getAttribute('data-hf3-act'), st = evaluate();
        if (act === 'save') save();
        else if (act === 'cancel') { editing = false; draft = null; render(); }
        else if (act === 'find') { setTab('find'); }
        else if (act === 'edit') { editing = true; draft = null; tab = 'find'; render(); }
        else if (act === 'close') close();
        else if (act === 'use') { if (st.opt && useSize(st.opt)) close(); }
        else if (act === 'alt0') { if (st.av && st.av.alts[0] && useSize(st.opt, st.av.alts[0])) close(); }
        return;
      }
      if (t.closest('[data-hf3-more]')) { var b = $('.hf3-body', modal); b.scrollBy({ top: b.clientHeight * 0.7, behavior: 'smooth' }); }
    }
    function onKey(e) {
      if (e.key === 'Escape') { e.stopPropagation(); close(); return; }
      if (e.key === 'Enter' && e.target && e.target.matches && e.target.matches('.hf3-form input')) { e.preventDefault(); save(); return; }
      if ((e.key === 'ArrowRight' || e.key === 'ArrowLeft') && e.target.closest && e.target.closest('.hf3-tabs')) { setTab(tab === 'guide' ? 'find' : 'guide', true); e.preventDefault(); return; }
      if (e.key === 'Tab') {
        var f = $$('button:not([disabled]), input, a[href]', modal).filter(function (x) { return x.offsetParent !== null && x.getAttribute('tabindex') !== '-1'; });
        if (!f.length) return;
        if (e.shiftKey && document.activeElement === f[0]) { f[f.length - 1].focus(); e.preventDefault(); }
        else if (!e.shiftKey && document.activeElement === f[f.length - 1]) { f[0].focus(); e.preventDefault(); }
      }
    }

    /* ---------- wiring ---------- */
    document.addEventListener('click', function (e) {
      var t = e.target.closest ? e.target : null; if (!t || !line || !line.contains(t)) return;
      var o = t.closest('[data-hf3-open]');
      if (o) { e.preventDefault(); var st = evaluate(); open(o.getAttribute('data-hf3-open'), st.s === 'need' ? ctx.primary : null); return; }
      if (t.closest('[data-hf3-use]')) { e.preventDefault(); var s2 = evaluate(); if (s2.opt) useSize(s2.opt); }
    });
    A.onChange(function () { setTimeout(renderLine, 40); });
    document.addEventListener('hp:profile', function () { renderLine(); });
    window.addEventListener('storage', function (e) { if (e.key === PK || e.key === UK) { unit = getUnit(); renderLine(); if (modal && modal.classList.contains('is-open') && !editing) render(); } });
    renderLine();
    return { open: open, close: close, evaluate: evaluate, ctx: ctx };
  }

  /* ================= profile bar + editor for listing pages (outfits that fit) ================= */
  function ProfileBar(el, opts) {
    // opts: {onChange(prof), title(prof), sub(prof)}
    var unit = getUnit(), editing = false, draft = null, clearArm = false;
    var roles = { chest: 'need', back: 'rec', neck: 'rec' };
    function view() { return opts.view ? opts.view() : getProfile(); }
    function render() {
      var p = view(), ok = p && num(p.chest) !== null;
      var form = !ok || editing;
      var h = opts.compact
        ? '<div class="hf3-bar-head"><p class="hf3-bar-sub">' + esc(opts.sub(p)) + '</p>' + unitToggle(unit) + '</div>'
        : '<div class="hf3-bar-head"><div><h2 class="hf3-bar-title">' + esc(opts.title(p)) + '</h2><p class="hf3-bar-sub">' + esc(opts.sub(p)) + '</p></div>' + unitToggle(unit) + '</div>';
      if (!form && opts.note) h += opts.note(p) || '';
      if (form) {
        var d = draft || Object.assign({}, getProfile() || {}, p || {});
        h += '<div class="hf3-bar-form">' + (ok ? '' : '<p class="hf3-text">' + (p && hasAny(p, Object.keys(F)) ? 'Add ' + esc(poss(p)) + ' chest to see clothing that fits.' : 'Enter your dog’s measurements — chest is all you need to start; back length and neck make the match more precise.') + '</p>') +
          formHtml({ id: 'hf3-b', fields: CLOTHING, roles: roles, prof: p, draft: d, unit: unit }) +
          '<div class="hf3-bar-acts"><button type="button" class="hf3-btn hf3-btn--primary" data-hf3b="save">' + (opts.saveLabel || (ok ? 'Update results' : 'Show outfits that fit')) + '</button>' + (ok ? '<button type="button" class="hf3-btn hf3-btn--text" data-hf3b="cancel">Cancel</button>' : '') +
          (p && hasAny(p, Object.keys(F)) ? '<button type="button" class="hf3-tlink hf3-danger" data-hf3b="clear">' + (clearArm ? 'Tap again to clear everything' : 'Clear saved measurements') + '</button>' : '') + '</div>' +
          '<p class="hf3-small">Saved on this device — no account needed.</p></div>';
      } else {
        h += '<div class="hf3-bar-vals"><ul class="hf3-vals">' + CLOTHING.map(function (k) { var v = num(p[k]); return '<li class="' + (v === null ? 'is-miss' : '') + '"><span>' + esc(F[k].label) + '</span><b>' + (v === null ? 'Not added' : esc(wu(v, unit))) + '</b></li>'; }).join('') + '</ul><div class="hf3-bar-btns"><button type="button" class="hf3-btn hf3-btn--ghost" data-hf3b="edit">Edit measurements</button>' + (opts.extra || '') + '</div></div>';
      }
      el.innerHTML = h;
      el.classList.add('hf3-root', 'hf3-bar');
      el.classList.toggle('is-compact', !!opts.compact);
    }
    function capture() { var r = $('[data-hf3-form]', el); if (r) draft = readForm(r, unit, roles, draft || Object.assign({}, getProfile() || {}, view() || {})).draft; }
    el.addEventListener('click', function (e) {
      var x = e.target.closest && e.target.closest('[data-hf3b],[data-hf3-unit]'); if (!x) return;
      var u = x.getAttribute('data-hf3-unit');
      if (u) { if (u === unit) return; capture(); unit = u; setUnit(u); render(); opts.onChange(getProfile(), 'unit'); return; }
      var a = x.getAttribute('data-hf3b');
      if (a === 'usesaved') { opts.onChange(getProfile(), 'save'); return; }
      if (a === 'edit') { editing = true; draft = null; render(); var f = $('input[data-k="chest"]', el); if (f) f.focus(); }
      else if (a === 'cancel') { editing = false; draft = null; render(); }
      else if (a === 'clear') {
        if (!clearArm) { capture(); clearArm = true; render(); return; }
        clearProfile(); clearArm = false; draft = {}; editing = true; render(); opts.onChange(null, 'clear');
      } else if (a === 'save') {
        var r = $('[data-hf3-form]', el), res = readForm(r, unit, roles, draft || Object.assign({}, getProfile() || {}, view() || {}));
        if (!showErrors(r, res.errors)) return;
        var p = commit(res.draft); editing = false; draft = null; render(); opts.onChange(p, 'save');
      }
    });
    el.addEventListener('keydown', function (e) { if (e.key === 'Enter' && e.target.matches && e.target.matches('.hf3-form input')) { e.preventDefault(); var b = $('[data-hf3b="save"]', el); if (b) b.click(); } });
    window.addEventListener('storage', function (e) { if (e.key === PK || e.key === UK) { unit = getUnit(); if (!editing) { render(); opts.onChange(getProfile(), 'storage'); } } });
    render();
    return { render: render, unit: function () { return unit; } };
  }

  /* ================= outfits that fit (client-side, used on Shopify) ================= */
  function Outfits(root) {
    var src = root.getAttribute('data-src') || '/collections/clothing', sec = root.getAttribute('data-section') || 'hype-fit-index';
    var cacheKey = 'hf3_idx2_' + src;
    var items = null, barEl = $('[data-hf3-outfits-bar]', root), out = $('[data-hf3-outfits-results]', root);
    var bar = ProfileBar(barEl, {
      title: function (p) { return p && num(p.chest) !== null ? 'Outfits that fit ' + who(p) : 'Shop outfits that fit your dog'; },
      sub: function (p) { return p && num(p.chest) !== null ? 'Each style is checked against its own size chart using ' + poss(p) + ' ' + listJoin(CLOTHING.filter(function (k) { return num(p[k]) !== null; }).map(lower)) + '. Only sizes in stock are shown.' : 'We check every style’s own size chart and show only the ones with your dog’s size in stock.'; },
      onChange: function () { draw(); }
    });
    function load() {
      try { var c = JSON.parse(sessionStorage.getItem(cacheKey) || 'null'); if (c && Date.now() - c.t < 10 * 60 * 1000) { items = c.items; return Promise.resolve(items); } } catch (e) {}
      var all = [], seen = {};
      function page(n) {
        return fetch(src + '?section_id=' + encodeURIComponent(sec) + '&page=' + n, { credentials: 'same-origin' }).then(function (r) { return r.text(); }).then(function (t) {
          var m = t.match(/<script type="application\/json" data-hf3-index>([\s\S]*?)<\/script>/);
          var d = m ? JSON.parse(m[1]) : { items: [], pages: 1 };
          d.items.forEach(function (it) { if (!seen[it.id]) { seen[it.id] = 1; all.push(it); } });
          return n < d.pages && n < 20 ? page(n + 1) : all;
        });
      }
      return page(1).then(function (a) { items = a; try { sessionStorage.setItem(cacheKey, JSON.stringify({ t: Date.now(), items: a })); } catch (e) {} return a; });
    }
    /* chart row index -> product size value (sizes the product is made in), same matching as the product page */
    function rowsToSizes(rows, vals) {
      var used = {}, ro = {};
      rows.forEach(function (r, i) { var h = vals.filter(function (v) { return norm(v) === norm(r.size); }); if (h.length === 1 && !used[h[0]]) { ro[i] = h[0]; used[h[0]] = 1; } });
      rows.forEach(function (r, i) { if (ro[i]) return; var b = base(r.size) || norm(r.size); var h = vals.filter(function (v) { return !used[v] && (base(v) || norm(v)) === b; }); if (h.length === 1) { ro[i] = h[0]; used[h[0]] = 1; } });
      return ro;
    }
    /* optional shopping filters (brand, product type) — kept in the URL; measurements stay in the profile */
    var F2 = (function () { var q = new URLSearchParams(location.search); return { brand: q.get('brand') || '', type: q.get('type') || '' }; })();
    function setF(k, v, push) {
      F2[k] = v || '';
      var q = new URLSearchParams(location.search);
      ['brand', 'type'].forEach(function (x) { if (F2[x]) q.set(x, F2[x]); else q.delete(x); });
      var u = location.pathname + (q.toString() ? '?' + q.toString() : '');
      try { history[push ? 'pushState' : 'replaceState']({}, '', u); } catch (e) {}
      shown = 24; draw();
    }
    window.addEventListener('popstate', function () { var q = new URLSearchParams(location.search); F2.brand = q.get('brand') || ''; F2.type = q.get('type') || ''; draw(); });
    var why = { over: 0, under: 0, other: 0, soldout: 0 };
    function match(p) {
      var res = []; why = { over: 0, under: 0, other: 0, soldout: 0 };
      items.forEach(function (it) {
        var c = it.chart; if (!c || !c.rows || !c.rows.length) return;
        var chart = { fitProfile: c.fit_profile || 'regular_clothing', measurements: c.measurements, rows: c.rows };
        if (chart.fitProfile === 'footwear' || chart.fitProfile === 'headwear') return;
        var ro = rowsToSizes(chart.rows, it.sizes);
        var r = _(chart, p, chart.rows.map(function (x, i) { return !!ro[i]; })).recommend(); // same rule as the product page
        if (r.status !== 'ok') { if (r.status === 'nomatch' && (r.dir === 'over' || r.dir === 'under')) why[r.dir]++; else why.other++; return; }
        var hit = [ro[r.recIdx]];
        var v = it.variants.filter(function (x) { return x.o[it.si] === hit[0] && x.a; })[0];
        if (!v) { why.soldout++; return; }
        res.push({ it: it, size: hit[0], vid: v.id, between: r.between });
      });
      return res;
    }
    function showMore(on) { var mb = $('[data-hf3-more]', root); if (mb) mb.hidden = !on; }
    function draw() {
      var p = getProfile();
      if (!p || num(p.chest) === null) { showMore(false); out.innerHTML = '<div class="hf3-empty"><p>Add ' + esc(poss(p)) + ' chest above to see every outfit with ' + esc(poss(p)) + ' size in stock.</p></div>'; return; }
      if (!items) { out.innerHTML = '<div class="hf3-loading" role="status"><span class="hf3-spin"></span>Checking every size chart…</div>'; load().then(draw).catch(function () { showMore(false); out.innerHTML = '<div class="hf3-empty is-error"><h3>We couldn’t load the styles just now</h3><p>This is a connection problem on our side — not a sizing result. Please try again.</p><div class="hf3-bar-acts"><button type="button" class="hf3-btn hf3-btn--ghost" data-hf3-retry>Try again</button></div></div>'; var rb = $('[data-hf3-retry]', out); if (rb) rb.addEventListener('click', function () { try { sessionStorage.removeItem(cacheKey); } catch (e) {} draw(); }); }); return; }
      var m = match(p);
      showMore(false);
      track('fit_outfits_view', { results: m.length });
      if (!m.length) {
        var tot = why.over + why.under + why.other, msg, h = 'No clothing matches these measurements right now';
        if (why.soldout) { h = 'Clothing in ' + poss(p) + ' size is sold out right now'; msg = why.soldout + (why.soldout === 1 ? ' style comes' : ' styles come') + ' in ' + poss(p) + ' size but ' + (why.soldout === 1 ? 'is' : 'are') + ' sold out at the moment. New drops arrive regularly — check back soon.'; }
        else if (tot && why.over / tot > 0.6) msg = Poss(p) + ' chest (' + wu(num(p.chest), getUnit()) + ') is larger than the biggest sizes in our clothing right now.';
        else if (tot && why.under / tot > 0.6) msg = Poss(p) + ' chest (' + wu(num(p.chest), getUnit()) + ') is smaller than the smallest sizes in our clothing right now.';
        else msg = 'No style currently has ' + poss(p) + ' size in stock.';
        out.innerHTML = '<div class="hf3-empty"><h3>' + esc(h) + '</h3><p>' + esc(msg) + ' Double-check the measurements above (snug tape, dog standing).</p><div class="hf3-bar-acts">' + (A.sizeGuideUrl ? '<a class="hf3-btn hf3-btn--ghost" href="' + esc(A.sizeGuideUrl) + '">How to measure</a>' : '') + '</div></div>';
        showMore(true);
        return;
      }
      var key = JSON.stringify([p.chest, p.back, p.neck]);
      if (key !== lastKey) { shown = 24; lastKey = key; }
      /* filter options are built from the matching styles, so counts always agree with what's shown */
      function opts(field, other) {
        var c = {};
        m.forEach(function (x) { if (other && F2[other] && (other === 'brand' ? x.it.v : x.it.t) !== F2[other]) return; var v = field === 'brand' ? x.it.v : x.it.t; if (v) c[v] = (c[v] || 0) + 1; });
        return Object.keys(c).sort().map(function (k) { return [k, c[k]]; });
      }
      var bOpts = opts('brand', 'type'), tOpts = opts('type', 'brand');
      var fm = m.filter(function (x) { return (!F2.brand || x.it.v === F2.brand) && (!F2.type || x.it.t === F2.type); });
      var sel = function (k, label, list) {
        var cur = F2[k], has = list.some(function (o) { return o[0] === cur; });
        return '<label class="hf3-fsel"><span>' + label + '</span><select data-hf3-f="' + k + '"><option value="">All</option>' + list.map(function (o) { return '<option value="' + esc(o[0]) + '"' + (o[0] === cur ? ' selected' : '') + '>' + esc(o[0]) + ' (' + o[1] + ')</option>'; }).join('') + (cur && !has ? '<option value="' + esc(cur) + '" selected>' + esc(cur) + ' (0)</option>' : '') + '</select></label>';
      };
      var chips = ['brand', 'type'].filter(function (k) { return F2[k]; }).map(function (k) { return '<button type="button" class="hf3-chip" data-hf3-rm="' + k + '" aria-label="Remove ' + esc(F2[k]) + ' filter">' + esc(F2[k]) + ' ' + IC.x + '</button>'; }).join('');
      var filt = '<div class="hf3-filters">' + sel('brand', 'Brand', bOpts) + (tOpts.length > 1 || F2.type ? sel('type', 'Category', tOpts) : '') + '</div>' +
        (chips ? '<div class="hf3-active">' + chips + '<button type="button" class="hf3-tlink" data-hf3-clear-f>Clear all filters</button></div>' : '');
      var label = [F2.brand, F2.type].filter(Boolean).join(' ');
      if (!fm.length) {
        out.innerHTML = filt + '<div class="hf3-empty is-filtered"><h3>No ' + esc(label) + ' styles fit ' + esc(who(p)) + ' right now</h3><p>' + m.length + ' other ' + (m.length === 1 ? 'style does' : 'styles do') + ' — remove the filter to see them.</p><div class="hf3-bar-acts"><button type="button" class="hf3-btn hf3-btn--primary" data-hf3-clear-f>Remove ' + esc(label || 'filters') + '</button></div></div>';
        return;
      }
      m = fm;
      var more = m.length - shown;
      out.innerHTML = filt + '<p class="hf3-count"><b>' + m.length + '</b> ' + (label ? esc(label) + ' ' : '') + (m.length === 1 ? 'style fits ' : 'styles fit ') + esc(who(p)) + '</p><ul class="hf3-cards">' + m.slice(0, shown).map(function (x) {
        var it = x.it;
        return '<li class="hf3-card"><a href="' + esc(it.url + (it.url.indexOf('?') > -1 ? '&' : '?') + 'variant=' + x.vid) + '" data-hf3-card>' +
          '<span class="hf3-card-img">' + (it.img ? '<img src="' + esc(it.img) + '" alt="' + esc(it.title) + '" loading="lazy" width="500" height="500">' : '') + '<span class="hf3-card-size">' + IC.check + 'Size ' + esc(x.size) + '</span></span>' +
          '<span class="hf3-card-t">' + esc(it.title) + '</span><span class="hf3-card-p">' + (it.from ? 'From ' : '') + (it.cmp ? '<s>' + esc(it.cmp) + '</s> ' : '') + esc(it.price) + '</span>' +
          (x.between ? '<span class="hf3-card-n">Between sizes — sized up</span>' : '') + '</a></li>';
      }).join('') + '</ul>' + (more > 0 ? '<div class="hf3-morewrap"><button type="button" class="hf3-btn hf3-btn--ghost" data-hf3-showmore>Show ' + Math.min(more, 24) + ' more <small>(' + more + ' left)</small></button></div>' : '') +
        '<p class="hf3-small hf3-center">Only styles with a verified size chart are included. Hats and shoes are sized separately on their own pages.</p>';
    }
    var shown = 24, lastKey = '';
    out.addEventListener('click', function (e) {
      if (!e.target.closest) return;
      if (e.target.closest('[data-hf3-card]')) track('fit_outfit_click', {});
      if (e.target.closest('[data-hf3-showmore]')) { shown += 24; draw(); }
      var rm = e.target.closest('[data-hf3-rm]'); if (rm) { setF(rm.getAttribute('data-hf3-rm'), '', true); return; }
      if (e.target.closest('[data-hf3-clear-f]')) { F2.type = ''; setF('brand', '', true); }
    });
    out.addEventListener('change', function (e) { var sl = e.target.closest && e.target.closest('[data-hf3-f]'); if (sl) { setF(sl.getAttribute('data-hf3-f'), sl.value, true); track('fit_outfits_filter', { field: sl.getAttribute('data-hf3-f') }); } });
    draw();
  }


  /* ================= Size Guide page (shared design with the product-page interface) ================= */
  function GuidePage(root) {
    var outfits = root.getAttribute('data-outfits') || '';
    var miniEdit = {};
    function setSaved() {
      var p = getProfile() || {}, u = getUnit();
      $$('[data-hf3-saved]', root).forEach(function (em) { var v = num(p[em.getAttribute('data-hf3-saved')]); em.innerHTML = v === null ? '' : IC.check + 'Saved: ' + esc(wu(v, u)); em.hidden = v === null; });
      var ok = num(p.chest) !== null, h = $('[data-hf3-sg-cta-h]', root), t = $('[data-hf3-sg-cta-p]', root), a = $('[data-hf3-sg-cta]', root);
      if (h) h.textContent = 'Shop outfits that fit ' + who(p);
      if (t) t.textContent = ok ? 'Every style checked against ' + poss(p) + ' measurements. Only sizes in stock.' : 'Add ' + poss(p) + ' chest above and we’ll show every style in their size.';
      if (a) {
        if (ok) { a.textContent = 'Shop outfits that fit ' + who(p); a.setAttribute('href', A.outfitsUrl ? (A.outfitsUrl(p) || outfits) : outfits); }
        else { a.textContent = 'Add measurements'; a.setAttribute('href', '#hf3-sg-profile'); }
      }
    }
    function mini(el, kind) {
      var fields = kind === 'head' ? ['head'] : ['paw_length', 'paw_width'];
      var roles = kind === 'head' ? { head: 'need' } : { paw_length: 'need', paw_width: 'used' };
      function draw(msg) {
        var p = getProfile() || {}, u = getUnit(), has = num(p[fields[0]]) !== null;
        if (has && !miniEdit[kind]) {
          el.innerHTML = '<div class="hf3-sg-saved">' + IC.check + '<span>Saved: ' + fields.filter(function (k) { return num(p[k]) !== null; }).map(function (k) { return esc(F[k].label) + ' ' + esc(wu(num(p[k]), u)); }).join(' · ') + '</span><button type="button" class="hf3-tlink" data-mini="edit">Edit</button></div>' + (msg ? '<p class="hf3-small">' + esc(msg) + '</p>' : '');
          return;
        }
        el.innerHTML = formHtml({ id: 'hf3-sg-' + kind, fields: fields, roles: roles, prof: p, unit: u, nameField: false }) +
          '<div class="hf3-bar-acts"><button type="button" class="hf3-btn hf3-btn--ghost" data-mini="save">Save</button>' + (has ? '<button type="button" class="hf3-btn hf3-btn--text" data-mini="cancel">Cancel</button>' : '') + '</div>';
      }
      el.addEventListener('click', function (e) {
        var b = e.target.closest && e.target.closest('[data-mini]'); if (!b) return;
        var a = b.getAttribute('data-mini');
        if (a === 'edit') { miniEdit[kind] = true; draw(); var f = $('input', el); if (f) f.focus(); }
        else if (a === 'cancel') { miniEdit[kind] = false; draw(); }
        else if (a === 'save') {
          var f2 = $('[data-hf3-form]', el), res = readForm(f2, getUnit(), roles, startDraft());
          if (!showErrors(f2, res.errors)) return;
          commit(res.draft); miniEdit[kind] = false; draw(kind === 'head' ? 'Used on hats and headwear.' : 'Used on shoes and boots.');
        }
      });
      el.addEventListener('keydown', function (e) { if (e.key === 'Enter' && e.target.matches && e.target.matches('input')) { e.preventDefault(); var s2 = $('[data-mini="save"]', el); if (s2) s2.click(); } });
      draw();
      return draw;
    }
    var redraw = [];
    $$('[data-hf3-sg-form]', root).forEach(function (el) { redraw.push(mini(el, el.getAttribute('data-hf3-sg-form'))); });
    var host = $('[data-hf3-sg-profile]', root);
    if (host) ProfileBar(host, {
      title: function (p) { return p && dogName(p) ? Poss(p) + ' measurements' : 'Your pup’s measurements'; },
      sub: function () { return 'Chest, back length and neck cover our clothing. Saved on this device — no account needed.'; },
      saveLabel: 'Save measurements',
      onChange: function () { setSaved(); redraw.forEach(function (d) { d(); }); }
    });
    document.addEventListener('hp:profile', setSaved);
    document.addEventListener('hp:unit', function () { setSaved(); redraw.forEach(function (d) { d(); }); });
    setSaved();
  }

  /* ================= boot ================= */
  function boot() {
    if (window.HF3) return;
    var api = { version: '3.0.0', getProfile: getProfile, recommend: function (chart, p) { return _(chart, p || getProfile()).recommend(); }, ProfileBar: ProfileBar };
    window.HF3 = api;
    var D = A.data && A.data();
    if (D && D.chart && D.chart.rows && D.chart.rows.length && D.sizeIdx > -1) {
      var pdp = PDP(D);
      if (pdp) { api.open = pdp.open; api.close = pdp.close; api.state = pdp.evaluate; document.documentElement.classList.add('hf3-on'); }
    }
    $$('[data-hf3-outfits]').forEach(function (el) { Outfits(el); });
    $$('[data-hf3-guide-page]').forEach(function (el) { GuidePage(el); });
    if (A.boot) A.boot(api);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
